// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@600;700&family=IBM+Plex+Sans:wght@400;500;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Select session template — mobile sheet first, desktop dialog. */
.sst-dialog__paper {
  --sst-brand: var(--brand-primary, #0877bc);
  --sst-brand-secondary: var(--brand-secondary, #46528b);
  --sst-ink: var(--text-color, #0f172a);
  --sst-muted: var(--text-secondary, #64748b);
  --sst-surface: var(--surface-color, #fff);
  --sst-line: color-mix(in srgb, var(--border-color, #e2e8f0) 75%, var(--sst-brand));
  --sst-display: "Barlow Condensed", "Arial Narrow", Impact, sans-serif;
  --sst-body: "IBM Plex Sans", Poppins, system-ui, sans-serif;
  --sst-ease: cubic-bezier(0.22, 1, 0.36, 1);

  display: flex !important;
  flex-direction: column;
  overflow: hidden;
  margin: 0;
  max-height: min(92vh, 760px);
  border-radius: 20px;
  background:
    radial-gradient(
      120% 60% at 0% 0%,
      color-mix(in srgb, var(--sst-brand) 14%, transparent) 0%,
      transparent 55%
    ),
    var(--sst-surface);
  color: var(--sst-ink);
  font-family: var(--sst-body);
  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.22);
}

.sst-dialog__paper--mobile {
  max-height: none;
  height: 100%;
  border-radius: 0;
  padding-bottom: env(safe-area-inset-bottom, 0);
}

.sst-dialog__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  flex-shrink: 0;
  padding:
    max(1rem, env(safe-area-inset-top, 0px))
    1rem
    0.85rem;
  border-bottom: 1px solid color-mix(in srgb, var(--sst-line) 55%, transparent);
}

.sst-dialog__header-copy {
  min-width: 0;
}

.sst-dialog__kicker {
  margin: 0 0 0.15rem;
  font-size: 0.68rem;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--sst-muted);
}

.sst-dialog__title {
  margin: 0;
  font-family: var(--sst-display);
  font-size: clamp(1.55rem, 5.5vw, 1.9rem);
  font-weight: 700;
  line-height: 0.95;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: var(--sst-ink);
}

.sst-dialog__subtitle {
  margin: 0.35rem 0 0;
  font-size: 0.82rem;
  color: var(--sst-muted);
}

.sst-dialog__close {
  color: var(--sst-muted) !important;
  background: color-mix(in srgb, var(--sst-brand) 8%, transparent) !important;
}

.sst-dialog__body {
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
  padding: 0.85rem 1rem 1rem;
  -webkit-overflow-scrolling: touch;
}

.sst-dialog__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
}

.sst-dialog__state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.65rem;
  min-height: 12rem;
  padding: 1.5rem 1rem;
  text-align: center;
  color: var(--sst-muted);
}

.sst-dialog__empty-icon {
  font-size: 2.4rem !important;
  color: color-mix(in srgb, var(--sst-brand) 55%, var(--sst-muted));
  opacity: 0.85;
}

.sst-dialog__empty-title {
  margin: 0;
  font-family: var(--sst-display);
  font-size: 1.25rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: var(--sst-ink);
}

.sst-dialog__empty-hint {
  margin: 0;
  max-width: 18rem;
  font-size: 0.86rem;
  line-height: 1.4;
}

.sst-card {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
  padding: 0.9rem 0.95rem;
  border-radius: 16px;
  border: 1.5px solid color-mix(in srgb, var(--sst-line) 70%, transparent);
  background: color-mix(in srgb, var(--sst-surface) 92%, #f8fafc);
  text-align: left;
  color: inherit;
  font: inherit;
  cursor: pointer;
  transition:
    border-color 0.18s var(--sst-ease),
    background 0.18s var(--sst-ease),
    box-shadow 0.18s var(--sst-ease),
    transform 0.12s var(--sst-ease);
}

.sst-card:hover:not(:disabled) {
  border-color: color-mix(in srgb, var(--sst-brand) 45%, var(--sst-line));
  box-shadow: 0 8px 22px color-mix(in srgb, var(--sst-brand) 12%, transparent);
}

.sst-card:focus-visible {
  outline: 2px solid var(--sst-brand);
  outline-offset: 2px;
}

.sst-card.is-selected {
  border-color: var(--sst-brand);
  background:
    linear-gradient(
      160deg,
      color-mix(in srgb, var(--sst-brand) 12%, transparent) 0%,
      color-mix(in srgb, var(--sst-surface) 96%, #fff) 55%
    );
  box-shadow:
    0 0 0 1px color-mix(in srgb, var(--sst-brand) 35%, transparent),
    0 12px 28px color-mix(in srgb, var(--sst-brand) 16%, transparent);
}

.sst-card:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.sst-card__top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.6rem;
}

.sst-card__titles {
  min-width: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.4rem 0.55rem;
}

.sst-card__name {
  margin: 0;
  font-family: var(--sst-display);
  font-size: 1.2rem;
  font-weight: 700;
  line-height: 1.05;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

.sst-card__kind {
  display: inline-flex;
  align-items: center;
  padding: 0.12rem 0.45rem;
  border-radius: 999px;
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--sst-brand-secondary);
  background: color-mix(in srgb, var(--sst-brand-secondary) 14%, transparent);
}

.sst-card__kind--layout {
  color: #0f766e;
  background: color-mix(in srgb, #0f766e 14%, transparent);
}

.sst-card__kind--session {
  color: var(--sst-brand);
  background: color-mix(in srgb, var(--sst-brand) 14%, transparent);
}

.sst-card__check {
  flex-shrink: 0;
  width: 1.5rem;
  height: 1.5rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  font-size: 1.35rem;
  color: transparent;
  border: 1.5px solid color-mix(in srgb, var(--sst-muted) 35%, transparent);
  transition:
    color 0.15s var(--sst-ease),
    border-color 0.15s var(--sst-ease),
    background 0.15s var(--sst-ease);
}

.sst-card__check.is-on {
  color: #fff;
  border-color: var(--sst-brand);
  background: var(--sst-brand);
}

.sst-card__desc {
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-size: 0.84rem;
  line-height: 1.4;
  color: var(--sst-muted);
}

.sst-card__metrics {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
}

.sst-metric {
  display: inline-flex;
  align-items: center;
  gap: 0.28rem;
  padding: 0.28rem 0.55rem;
  border-radius: 999px;
  border: 1px solid color-mix(in srgb, var(--sst-line) 65%, transparent);
  background: color-mix(in srgb, var(--sst-brand) 6%, var(--sst-surface));
  font-size: 0.74rem;
  color: var(--sst-muted);
}

.sst-metric strong {
  font-size: 0.86rem;
  font-weight: 700;
  color: var(--sst-ink);
}

.sst-metric__icon {
  font-size: 0.95rem !important;
  color: var(--sst-brand);
}

.sst-card__seq {
  list-style: none;
  margin: 0;
  padding: 0.35rem 0 0;
  display: flex;
  flex-direction: column;
  gap: 0.28rem;
  border-top: 1px dashed color-mix(in srgb, var(--sst-line) 70%, transparent);
}

.sst-card__seq li {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 0.45rem;
  min-width: 0;
}

.sst-card__seq-n {
  width: 1.2rem;
  height: 1.2rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  font-family: var(--sst-display);
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: var(--sst-brand);
  background: color-mix(in srgb, var(--sst-brand) 12%, transparent);
}

.sst-card__seq-name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.78rem;
  font-weight: 500;
  color: var(--sst-ink);
}

.sst-card__seq-name--personalized {
  color: var(--sst-brand);
  font-weight: 700;
}

.sst-card__seq-min {
  font-size: 0.7rem;
  font-weight: 600;
  color: var(--sst-muted);
  font-variant-numeric: tabular-nums;
}

.sst-card__seq-more {
  display: block !important;
  padding-left: 1.65rem;
  font-size: 0.72rem;
  font-weight: 600;
  color: var(--sst-muted);
}

.sst-dialog__footer {
  flex-shrink: 0;
  display: flex;
  gap: 0.55rem;
  padding:
    0.75rem 1rem
    max(0.85rem, env(safe-area-inset-bottom, 0px));
  border-top: 1px solid color-mix(in srgb, var(--sst-line) 55%, transparent);
  background: color-mix(in srgb, var(--sst-surface) 92%, #f1f5f9);
}

.sst-dialog__btn {
  flex: 1 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 2.75rem;
  padding: 0.65rem 1rem;
  border-radius: 12px;
  border: 1.5px solid transparent;
  font-family: var(--sst-body);
  font-size: 0.92rem;
  font-weight: 600;
  cursor: pointer;
  transition:
    background 0.15s var(--sst-ease),
    border-color 0.15s var(--sst-ease),
    opacity 0.15s var(--sst-ease),
    transform 0.1s var(--sst-ease);
}

.sst-dialog__btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.sst-dialog__btn--ghost {
  flex: 0 1 auto;
  min-width: 5.5rem;
  color: var(--sst-muted);
  background: transparent;
  border-color: color-mix(in srgb, var(--sst-line) 80%, transparent);
}

.sst-dialog__btn--ghost:hover:not(:disabled) {
  color: var(--sst-ink);
  background: color-mix(in srgb, var(--sst-muted) 8%, transparent);
}

.sst-dialog__btn--primary {
  color: #fff;
  background: linear-gradient(
    135deg,
    var(--sst-brand) 0%,
    color-mix(in srgb, var(--sst-brand) 78%, #000) 100%
  );
  border-color: var(--sst-brand);
  box-shadow: 0 10px 22px color-mix(in srgb, var(--sst-brand) 28%, transparent);
}

.sst-dialog__btn--primary:hover:not(:disabled) {
  transform: translateY(-1px);
}

@media (min-width: 600px) {
  .sst-dialog__header {
    padding: 1.15rem 1.25rem 0.95rem;
  }

  .sst-dialog__body {
    padding: 1rem 1.25rem 1.15rem;
  }

  .sst-dialog__footer {
    padding: 0.85rem 1.25rem 1.1rem;
  }

  .sst-dialog__list {
    display: grid;
    grid-template-columns: 1fr;
    gap: 0.8rem;
  }

  .sst-card:hover:not(:disabled) {
    transform: translateY(-1px);
  }
}

@media (min-width: 900px) {
  .sst-dialog__paper {
    max-width: 520px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .sst-card,
  .sst-dialog__btn {
    transition: none;
  }

  .sst-card:hover:not(:disabled),
  .sst-dialog__btn--primary:hover:not(:disabled) {
    transform: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/planning/SelectSessionTemplateDialog.css"],"names":[],"mappings":"AAEA,kEAAkE;AAClE;EACE,0CAA0C;EAC1C,sDAAsD;EACtD,qCAAqC;EACrC,2CAA2C;EAC3C,yCAAyC;EACzC,kFAAkF;EAClF,qEAAqE;EACrE,2DAA2D;EAC3D,0CAA0C;;EAE1C,wBAAwB;EACxB,sBAAsB;EACtB,gBAAgB;EAChB,SAAS;EACT,4BAA4B;EAC5B,mBAAmB;EACnB;;;;;;sBAMoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,cAAc;EACd;;;WAGS;EACT,6EAA6E;AAC/E;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,wCAAwC;EACxC,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,2EAA2E;AAC7E;;AAEA;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,iEAAiE;EACjE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,wEAAwE;EACxE,+DAA+D;EAC/D,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,eAAe;EACf;;;;mCAIiC;AACnC;;AAEA;EACE,uEAAuE;EACvE,4EAA4E;AAC9E;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B;;;;;KAKG;EACH;;qEAEmE;AACrE;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iCAAiC;EACjC,2EAA2E;AAC7E;;AAEA;EACE,cAAc;EACd,wDAAwD;AAC1D;;AAEA;EACE,uBAAuB;EACvB,iEAAiE;AACnE;;AAEA;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,yEAAyE;EACzE;;;oCAGkC;AACpC;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,oBAAoB;EACpB,sEAAsE;EACtE,uEAAuE;EACvE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,2EAA2E;AAC7E;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,iEAAiE;AACnE;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,YAAY;EACZ;;kDAEgD;EAChD,0EAA0E;EAC1E,+DAA+D;AACjE;;AAEA;EACE,SAAO;EACP,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf;;;;kCAIgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,uBAAuB;EACvB,uBAAuB;EACvB,kEAAkE;AACpE;;AAEA;EACE,qBAAqB;EACrB,gEAAgE;AAClE;;AAEA;EACE,WAAW;EACX;;;;GAIC;EACD,8BAA8B;EAC9B,6EAA6E;AAC/E;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,gCAAgC;EAClC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,aAAa;IACb,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;;IAEE,gBAAgB;EAClB;;EAEA;;IAEE,eAAe;EACjB;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@600;700&family=IBM+Plex+Sans:wght@400;500;600&display=swap\");\n\n/* Select session template — mobile sheet first, desktop dialog. */\n.sst-dialog__paper {\n  --sst-brand: var(--brand-primary, #0877bc);\n  --sst-brand-secondary: var(--brand-secondary, #46528b);\n  --sst-ink: var(--text-color, #0f172a);\n  --sst-muted: var(--text-secondary, #64748b);\n  --sst-surface: var(--surface-color, #fff);\n  --sst-line: color-mix(in srgb, var(--border-color, #e2e8f0) 75%, var(--sst-brand));\n  --sst-display: \"Barlow Condensed\", \"Arial Narrow\", Impact, sans-serif;\n  --sst-body: \"IBM Plex Sans\", Poppins, system-ui, sans-serif;\n  --sst-ease: cubic-bezier(0.22, 1, 0.36, 1);\n\n  display: flex !important;\n  flex-direction: column;\n  overflow: hidden;\n  margin: 0;\n  max-height: min(92vh, 760px);\n  border-radius: 20px;\n  background:\n    radial-gradient(\n      120% 60% at 0% 0%,\n      color-mix(in srgb, var(--sst-brand) 14%, transparent) 0%,\n      transparent 55%\n    ),\n    var(--sst-surface);\n  color: var(--sst-ink);\n  font-family: var(--sst-body);\n  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.22);\n}\n\n.sst-dialog__paper--mobile {\n  max-height: none;\n  height: 100%;\n  border-radius: 0;\n  padding-bottom: env(safe-area-inset-bottom, 0);\n}\n\n.sst-dialog__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.75rem;\n  flex-shrink: 0;\n  padding:\n    max(1rem, env(safe-area-inset-top, 0px))\n    1rem\n    0.85rem;\n  border-bottom: 1px solid color-mix(in srgb, var(--sst-line) 55%, transparent);\n}\n\n.sst-dialog__header-copy {\n  min-width: 0;\n}\n\n.sst-dialog__kicker {\n  margin: 0 0 0.15rem;\n  font-size: 0.68rem;\n  font-weight: 600;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--sst-muted);\n}\n\n.sst-dialog__title {\n  margin: 0;\n  font-family: var(--sst-display);\n  font-size: clamp(1.55rem, 5.5vw, 1.9rem);\n  font-weight: 700;\n  line-height: 0.95;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  color: var(--sst-ink);\n}\n\n.sst-dialog__subtitle {\n  margin: 0.35rem 0 0;\n  font-size: 0.82rem;\n  color: var(--sst-muted);\n}\n\n.sst-dialog__close {\n  color: var(--sst-muted) !important;\n  background: color-mix(in srgb, var(--sst-brand) 8%, transparent) !important;\n}\n\n.sst-dialog__body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow: auto;\n  padding: 0.85rem 1rem 1rem;\n  -webkit-overflow-scrolling: touch;\n}\n\n.sst-dialog__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.7rem;\n}\n\n.sst-dialog__state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.65rem;\n  min-height: 12rem;\n  padding: 1.5rem 1rem;\n  text-align: center;\n  color: var(--sst-muted);\n}\n\n.sst-dialog__empty-icon {\n  font-size: 2.4rem !important;\n  color: color-mix(in srgb, var(--sst-brand) 55%, var(--sst-muted));\n  opacity: 0.85;\n}\n\n.sst-dialog__empty-title {\n  margin: 0;\n  font-family: var(--sst-display);\n  font-size: 1.25rem;\n  font-weight: 700;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  color: var(--sst-ink);\n}\n\n.sst-dialog__empty-hint {\n  margin: 0;\n  max-width: 18rem;\n  font-size: 0.86rem;\n  line-height: 1.4;\n}\n\n.sst-card {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 0.55rem;\n  padding: 0.9rem 0.95rem;\n  border-radius: 16px;\n  border: 1.5px solid color-mix(in srgb, var(--sst-line) 70%, transparent);\n  background: color-mix(in srgb, var(--sst-surface) 92%, #f8fafc);\n  text-align: left;\n  color: inherit;\n  font: inherit;\n  cursor: pointer;\n  transition:\n    border-color 0.18s var(--sst-ease),\n    background 0.18s var(--sst-ease),\n    box-shadow 0.18s var(--sst-ease),\n    transform 0.12s var(--sst-ease);\n}\n\n.sst-card:hover:not(:disabled) {\n  border-color: color-mix(in srgb, var(--sst-brand) 45%, var(--sst-line));\n  box-shadow: 0 8px 22px color-mix(in srgb, var(--sst-brand) 12%, transparent);\n}\n\n.sst-card:focus-visible {\n  outline: 2px solid var(--sst-brand);\n  outline-offset: 2px;\n}\n\n.sst-card.is-selected {\n  border-color: var(--sst-brand);\n  background:\n    linear-gradient(\n      160deg,\n      color-mix(in srgb, var(--sst-brand) 12%, transparent) 0%,\n      color-mix(in srgb, var(--sst-surface) 96%, #fff) 55%\n    );\n  box-shadow:\n    0 0 0 1px color-mix(in srgb, var(--sst-brand) 35%, transparent),\n    0 12px 28px color-mix(in srgb, var(--sst-brand) 16%, transparent);\n}\n\n.sst-card:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.sst-card__top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.6rem;\n}\n\n.sst-card__titles {\n  min-width: 0;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.4rem 0.55rem;\n}\n\n.sst-card__name {\n  margin: 0;\n  font-family: var(--sst-display);\n  font-size: 1.2rem;\n  font-weight: 700;\n  line-height: 1.05;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n}\n\n.sst-card__kind {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.12rem 0.45rem;\n  border-radius: 999px;\n  font-size: 0.62rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--sst-brand-secondary);\n  background: color-mix(in srgb, var(--sst-brand-secondary) 14%, transparent);\n}\n\n.sst-card__kind--layout {\n  color: #0f766e;\n  background: color-mix(in srgb, #0f766e 14%, transparent);\n}\n\n.sst-card__kind--session {\n  color: var(--sst-brand);\n  background: color-mix(in srgb, var(--sst-brand) 14%, transparent);\n}\n\n.sst-card__check {\n  flex-shrink: 0;\n  width: 1.5rem;\n  height: 1.5rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 999px;\n  font-size: 1.35rem;\n  color: transparent;\n  border: 1.5px solid color-mix(in srgb, var(--sst-muted) 35%, transparent);\n  transition:\n    color 0.15s var(--sst-ease),\n    border-color 0.15s var(--sst-ease),\n    background 0.15s var(--sst-ease);\n}\n\n.sst-card__check.is-on {\n  color: #fff;\n  border-color: var(--sst-brand);\n  background: var(--sst-brand);\n}\n\n.sst-card__desc {\n  margin: 0;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  font-size: 0.84rem;\n  line-height: 1.4;\n  color: var(--sst-muted);\n}\n\n.sst-card__metrics {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n}\n\n.sst-metric {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.28rem;\n  padding: 0.28rem 0.55rem;\n  border-radius: 999px;\n  border: 1px solid color-mix(in srgb, var(--sst-line) 65%, transparent);\n  background: color-mix(in srgb, var(--sst-brand) 6%, var(--sst-surface));\n  font-size: 0.74rem;\n  color: var(--sst-muted);\n}\n\n.sst-metric strong {\n  font-size: 0.86rem;\n  font-weight: 700;\n  color: var(--sst-ink);\n}\n\n.sst-metric__icon {\n  font-size: 0.95rem !important;\n  color: var(--sst-brand);\n}\n\n.sst-card__seq {\n  list-style: none;\n  margin: 0;\n  padding: 0.35rem 0 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.28rem;\n  border-top: 1px dashed color-mix(in srgb, var(--sst-line) 70%, transparent);\n}\n\n.sst-card__seq li {\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  align-items: center;\n  gap: 0.45rem;\n  min-width: 0;\n}\n\n.sst-card__seq-n {\n  width: 1.2rem;\n  height: 1.2rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px;\n  font-family: var(--sst-display);\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  color: var(--sst-brand);\n  background: color-mix(in srgb, var(--sst-brand) 12%, transparent);\n}\n\n.sst-card__seq-name {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 0.78rem;\n  font-weight: 500;\n  color: var(--sst-ink);\n}\n\n.sst-card__seq-name--personalized {\n  color: var(--sst-brand);\n  font-weight: 700;\n}\n\n.sst-card__seq-min {\n  font-size: 0.7rem;\n  font-weight: 600;\n  color: var(--sst-muted);\n  font-variant-numeric: tabular-nums;\n}\n\n.sst-card__seq-more {\n  display: block !important;\n  padding-left: 1.65rem;\n  font-size: 0.72rem;\n  font-weight: 600;\n  color: var(--sst-muted);\n}\n\n.sst-dialog__footer {\n  flex-shrink: 0;\n  display: flex;\n  gap: 0.55rem;\n  padding:\n    0.75rem 1rem\n    max(0.85rem, env(safe-area-inset-bottom, 0px));\n  border-top: 1px solid color-mix(in srgb, var(--sst-line) 55%, transparent);\n  background: color-mix(in srgb, var(--sst-surface) 92%, #f1f5f9);\n}\n\n.sst-dialog__btn {\n  flex: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 2.75rem;\n  padding: 0.65rem 1rem;\n  border-radius: 12px;\n  border: 1.5px solid transparent;\n  font-family: var(--sst-body);\n  font-size: 0.92rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition:\n    background 0.15s var(--sst-ease),\n    border-color 0.15s var(--sst-ease),\n    opacity 0.15s var(--sst-ease),\n    transform 0.1s var(--sst-ease);\n}\n\n.sst-dialog__btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.sst-dialog__btn--ghost {\n  flex: 0 1 auto;\n  min-width: 5.5rem;\n  color: var(--sst-muted);\n  background: transparent;\n  border-color: color-mix(in srgb, var(--sst-line) 80%, transparent);\n}\n\n.sst-dialog__btn--ghost:hover:not(:disabled) {\n  color: var(--sst-ink);\n  background: color-mix(in srgb, var(--sst-muted) 8%, transparent);\n}\n\n.sst-dialog__btn--primary {\n  color: #fff;\n  background: linear-gradient(\n    135deg,\n    var(--sst-brand) 0%,\n    color-mix(in srgb, var(--sst-brand) 78%, #000) 100%\n  );\n  border-color: var(--sst-brand);\n  box-shadow: 0 10px 22px color-mix(in srgb, var(--sst-brand) 28%, transparent);\n}\n\n.sst-dialog__btn--primary:hover:not(:disabled) {\n  transform: translateY(-1px);\n}\n\n@media (min-width: 600px) {\n  .sst-dialog__header {\n    padding: 1.15rem 1.25rem 0.95rem;\n  }\n\n  .sst-dialog__body {\n    padding: 1rem 1.25rem 1.15rem;\n  }\n\n  .sst-dialog__footer {\n    padding: 0.85rem 1.25rem 1.1rem;\n  }\n\n  .sst-dialog__list {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 0.8rem;\n  }\n\n  .sst-card:hover:not(:disabled) {\n    transform: translateY(-1px);\n  }\n}\n\n@media (min-width: 900px) {\n  .sst-dialog__paper {\n    max-width: 520px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .sst-card,\n  .sst-dialog__btn {\n    transition: none;\n  }\n\n  .sst-card:hover:not(:disabled),\n  .sst-dialog__btn--primary:hover:not(:disabled) {\n    transform: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
